import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { ICentro, IDeleteCentroResponse, IUpdateCentroResponse } from '../../interfaces/centros.interface';
import {
  CreateCentro, CreateCentroSuccess, DeleteCentro, DeleteCentroSuccess,
  GetCentros, GetCentrosSuccess, UpdateCentro, UpdateCentroSuccess
} from '../actions/centros.actions';


@Injectable()
export class CentrosEffects {
  getCentros$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetCentros),
      switchMap(() =>
        this.apiService.getCentros().pipe(
          map((centros: ICentro[]) => GetCentrosSuccess({ centros }))
        )
      )
    )
  );

  createCentro$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateCentro),
      switchMap(payload =>
        this.apiService.createCentro(payload.centro).pipe(
          map((centro: ICentro) => CreateCentroSuccess({ centro }))
        )
      )
    )
  );

  deleteCentro$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteCentro),
      switchMap(payload =>
        this.apiService.deleteCentro(payload.id).pipe(
          map((centro: IDeleteCentroResponse) => DeleteCentroSuccess({ centro }))
        )
      )
    )
  );

  updateCentro$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateCentro),
      switchMap(payload =>
        this.apiService.updateCentro(payload.id, payload.centro).pipe(
          map((centro: IUpdateCentroResponse) => UpdateCentroSuccess({ centro }))
        )
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private store: Store<IAppState>
  ) { }
}
